module.exports = __webpack_public_path__ + "img/donante-masters-barber.861b339e.jpeg";